import React, { useContext } from 'react'
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { Autocomplete, AutocompleteRenderInputParams, Divider, FormControl, FormControlLabel, Grid, ListItemIcon, ListItemText, Radio, RadioGroup, TextField, Typography, useMediaQuery } from '@mui/material';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import IconsColor from '../../../../../utility/iconsColor';
import { primaryColor } from '../../../../../../utils/colors';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import workflowFormStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import GlobalButton from '../../../../../utility/globalButton/button';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import Required from '../../../../../utility/required';
import { emptyNewVariableFieldObj, getCustomVariableById } from '../../../flowBuilderConstants';
import RenderSourceVariable from './renderSourceVariable';
import RenderTargetVariable from './renderTargetVariable';
import RenderStaticValueField from './renderStaticValueField';

interface VariableToVariablePopupProps {
    actionData: any, 
    stepAction: any, 
    setFlagSaveVariableToVariablePopup: React.Dispatch<React.SetStateAction<boolean>>,
    handleCancelClick: () => void,
} 

export type combinedValueType = "source variable" | "target variable" | "assign radio btn" | "static value";
export type CombinedUpdateType = 
| { type: "source variable", value: customVariableDataInterface | null }
| { type: "target variable", value: customVariableDataInterface | null }
| { type: "assign radio btn", value: string }
| { type: "static value", value: string }

const VariableAssignmentPopup: React.FC<VariableToVariablePopupProps> = (props) => {
    
    const { actionData, stepAction, setFlagSaveVariableToVariablePopup, handleCancelClick } = props;
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={contactStyles.newTagNameUlElement}>
                    <Divider className={contactStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    } 

    const getValueOfFields = (type: combinedValueType) => {
        switch(type){
            case "source variable":
                return getCustomVariableById(customVariableList, actionData?.source_chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) ?? null;
            case "target variable":
                return getCustomVariableById(customVariableList, actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) ?? null;
            case "assign radio btn":
                return actionData?.source_chatbot_custom_variable_configuration ? false : true;
            case "static value":
                return actionData?.variable_static_value ?? "";
        }
    }

    const onChangeOfFields = ({ type, value }: CombinedUpdateType) => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
            {
                ...actionData,
                ...(type?.toLowerCase() == "source variable" && { flag_change_source_variable: true, chatbot_custom_variable_configuration: value }),
                ...(type?.toLowerCase() == "target variable" && { flag_change_target_variable: true, chatbot_custom_variable_configuration: value }),
                ...(type?.toLowerCase() == "assign radio btn" && { flag_change_assign_radio_btn: true, value: value == "true" }),
                ...(type?.toLowerCase() == "static value" && { flag_change_static_value: true, value: value }) 
            },
            {
                updateType: "editExistingStepAction"
            }
        ); 
    }

    const disabledSaveBtn = () => {
        if(!actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id || (!actionData?.source_chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id && !actionData?.variable_static_value?.trim())){
            return true;
        }
        return false;
    }

    const handleSaveClick = () => {
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "saving_payload_key_changes_in_BE" },
            {
                updateType: "editExistingStepAction"
            }
        );  
        setFlagSaveVariableToVariablePopup(false);
    }

    const getVariableOptions = () => {
        if(customVariableList?.custom_variable_data){
            return [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), emptyNewVariableFieldObj];
        } else {
            return [];
        } 
    }

    const renderInputForVariableAutoComplete = (params: AutocompleteRenderInputParams, placeholder: string) => {
        const { InputProps, ...restParams } = params;
        const { startAdornment, ...restInputProps } = InputProps;
        return (
            <TextField
                {...restParams}
                placeholder={placeholder}
                InputProps={{
                    ...restInputProps,
                    startAdornment: (
                        <div className={contactStyles.selectTagTextField}>
                            {startAdornment}
                        </div>
                    ),
                }}
            />
        );
    }

    const renderFormControlLabel = (value: boolean, label: string) => {
        return (
            <FormControlLabel 
                className={globalStyles.radioLabelStyle} 
                value={value} 
                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} 
                control={<Radio className={globalStyles.radioButton} />} 
                label={label} 
            />
        );
    }

    const checkIfOptionsisDisabled = (chatbot_custom_variable_configuration_id: string, configuration_id: string) => {
        return chatbot_custom_variable_configuration_id == configuration_id;
    }
    
    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>Variable Assignment</span>
                </Grid>
                <Grid item>
                    <Divider className={workflowFormStyles.resetVariableDivider} />
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={3}>

                        <Grid item xs={12}>
                            <Grid container gap={1}>
                                <Grid item xs={12}>
                                    <Typography className={styles.createWorkflowLabelStyle}>How do you want to assign value? <Required /></Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="variable-assignment-type-label"
                                            defaultValue=""
                                            name="variable-asignment-type"
                                            value={getValueOfFields("assign radio btn") as boolean}
                                            onChange={(event) => onChangeOfFields({type: "assign radio btn", value: event.target.value})}
                                        >
                                            {renderFormControlLabel(true, "Static Value")}
                                            {renderFormControlLabel(false, "From another variable")}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        {getValueOfFields("assign radio btn") ? 
                            <>
                                <RenderStaticValueField
                                    getValueOfFields={getValueOfFields}
                                    onChangeOfFields={onChangeOfFields}
                                />
                            </>
                            :
                            <>
                                <RenderSourceVariable 
                                    getVariableOptions={getVariableOptions}
                                    chatbot_custom_variable_configuration_id={actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id}
                                    checkIfOptionsisDisabled={checkIfOptionsisDisabled}
                                    getValueOfFields={getValueOfFields}
                                    onChangeOfFields={onChangeOfFields}
                                    renderOptions={renderOptions}
                                    renderInputForVariableAutoComplete={renderInputForVariableAutoComplete}
                                />
                            </>
                        }
                        <RenderTargetVariable
                            getVariableOptions={getVariableOptions}
                            chatbot_custom_variable_configuration_id={actionData?.source_chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id}
                            checkIfOptionsisDisabled={checkIfOptionsisDisabled}
                            getValueOfFields={getValueOfFields}
                            onChangeOfFields={onChangeOfFields}
                            renderOptions={renderOptions}
                            renderInputForVariableAutoComplete={renderInputForVariableAutoComplete}
                        />

                    </Grid>
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleCancelClick();
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                disabled={disabledSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleSaveClick();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default VariableAssignmentPopup
